module.exports = __webpack_public_path__ + "img/zhinengjiaju7.48a6bc41.jpg";